<template>
    <div class="main-container">
        <breadcrumb
            :list="breadcrumbList"
        ></breadcrumb>
        <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
      <tl-tabs :tabs="tabs" class="space" @changeTab="fetchAllEmployees">
          <tl-tab>
              <lop-rlop/>
          </tl-tab>
          <tl-tab>
              <employees-list :employeeLopDataList="employeeLopData"/>
          </tl-tab>
      </tl-tabs>
      
    </div>
</template>

<script>
import LopRlop from './uploadLopRlop.vue';
import EmployeesList from './employeesList.vue';
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  components:{
    LopRlop,EmployeesList
  },  
  data(){
    return{
      employeeLopData:[],
      toast:false,
      errmsg:'',
      tabs: [{
          header: 'Update LOP & RLOP'
        },
        {
          header: 'Employees List'
        }
      ],
      breadcrumbList:[
        {
          name:'Payroll',
          url:`/dashboard/${this.$route.params.entity_index}/payroll`
        },{
          name:'Utilities',
          url:`/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },{
          name:'Upload LOP & RLOP',
          url:`/dashboard/${this.$route.params.entity_index}/payroll/utilities/upload_lop_rlop`
        }
      ],
    }
  },
  activated(){
    this.fetchAllEmployees();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods:{
    ...mapActions({
      act_fetch: "dashboard/payroll/utilities/uploadloprlop/fetchAll",
    }),

    /* server call to get employee list */
    async fetchAllEmployees(){
      try {
        let res = await this.act_fetch({le_id:this.le_id});
        if(res.data.status){
          this.employeeLopData = res.data.payload;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }  
  
}
</script>

<style scoped style="scss">
.space{
  padding-top: 30px;
}
</style>
